import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class LoaderService {
    public loading$ = new BehaviorSubject<boolean>(false);
    private counter = 0;

    start() {
        if (this.counter === 0) {
            this.loading$.next(true);
        }
        this.counter++;
    }

    stop() {
        if (this.counter > 0) {
            this.counter--;
        }
        if (this.counter === 0) {
            this.loading$.next(false);
        }
    }
}
